import React, { useMemo } from 'react';
import { Formik, Form, FormikHelpers } from 'formik';

import './style.sass';

import { InputGroup } from '../common/InputGroup';
import { loginValidationSchema } from 'app/viewModels/pages/LoginPageViewModel';
import { UserAuthData } from 'src/types/user';
import { Button } from '../common/Button';
import { DividerWithText } from '../common/DividerWithText';

import googleLogo from 'assets/img/icons/google-logo.png';
import appleLogo from 'assets/img/icons/apple-logo.png';


type Props = {
    onSubmit: (data: UserAuthData) => void;
    onClickSignup: () => void;
    onClickResetPassword: () => void;
    onClickGoogleAuth: () => void;
    onClickAppleAuth: () => void;
 };

export const LoginForm = ({
    onSubmit,
    onClickSignup,
    onClickResetPassword,
    onClickGoogleAuth,
    onClickAppleAuth,
}: Props) => {
    const params = useMemo(() => new URLSearchParams(window.location.search), []);
    const userEmail = params.get('userEmail');
    const decodedEmail = userEmail ? decodeURIComponent(userEmail) : '';

    const initialValues = useMemo(() => ({
        email: decodedEmail,
        password: '',
    }), [decodedEmail]);

    const onSubmitForm = (data: UserAuthData, actions: FormikHelpers<UserAuthData>) => {
        const { resetForm } = actions;

        if (onSubmit) {
            onSubmit(data);
        }

        resetForm();
    };

    return (
        <div className="login-form">

            <div className="login-form__third-party-btns">
                <Button
                    className="login-form__google-btn"
                    type="submit"
                    text="Sign in with google"
                    size="big"
                    colorType="secondary"
                    iconSrc={googleLogo}
                    onClick={onClickGoogleAuth}
                />

                <Button
                    className="login-form__apple-btn"
                    type="submit"
                    text="Sign in with apple"
                    size="big"
                    colorType="secondary"
                    iconSrc={appleLogo}
                    onClick={onClickAppleAuth}
                />
            </div>

            <DividerWithText
                className="login-form__divider"
                text='Or'
            />

            <Formik
                initialValues={initialValues}
                validationSchema={loginValidationSchema}
                onSubmit={onSubmitForm}
                enableReinitialize
            >
                <Form>
                    <InputGroup
                        id="inputEmail"
                        name="email"
                        autoComplete="email"
                        placeholder="Email address"
                    />
                    <InputGroup
                        id="inputPassword"
                        name="password"
                        autoComplete="current-password"
                        placeholder="Password"
                        type="password"
                    />

                    <span className="login-form__forgot-pass p2-regular" onClick={onClickResetPassword}>
                        Forgot password?
                    </span>

                    <div className="login-form__buttons">
                        <Button
                            className="login-form__login-btn"
                            type="submit"
                            text="Login"
                            size="big"
                        />
                    </div>

                    <span className="login-form__sign-up p2-medium grey-1">
                        Not a member yet? <span className="login-form__sign-up-btn p2-semi-bold violet-text" onClick={onClickSignup}> Sign up now</span>
                    </span>
                </Form>
            </Formik>
        </div>
    );
};
